<template>
  <ul class="accordion">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  props: {
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Accordion: {
        alwaysOpen: this.alwaysOpen,
        count: 0,
        active: [],
      },
    };
  },
  provide() {
    return { Accordion: this.Accordion };
  },
  methods: {
    allClose() {
      this.Accordion.active = [];
    },
    allOpen() {
      //this.Accordion.active = Array.from({ length: this.Accordion.count }, (v, i) => i);
      this.Accordion.active = [0, 1, 2];
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item:last-child {
    border-bottom: none;
  }
}
</style>
